module.exports = __webpack_public_path__ + "img/ic_daily_attendance.91d00c08.png";